// extracted by mini-css-extract-plugin
module.exports = {"navLink":"vC","linkButtonFrame":"vD","linkButton":"vE","navLinkWhileSearching":"vF"};